import { closeModal, openModal } from '@/common/actions'

export const reducerName = 'addTelegram.modals'

export const openAddTelegramModal = openModal(reducerName)
export const closeAddTelegramModal = closeModal(reducerName)
